export default "__VITE_PUBLIC_ASSET__bea5a6b6__"